<template>
  <router-link v-if="locationId" class="btn btn-info" :to="'/integrations/platform-menu-imports/' + locationId">{{ $t('platformMenuImport.title') }}</router-link>
</template>
<script>
export default {
  props: { locationId: [Number, String] }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/PlatformMenuImports/PlatformMenuImportLink.vue